import type { ButtonHTMLAttributes, ReactNode } from "react";

export function Button({
  variant = "primary",
  className = "",
  children,
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "primary" | "ghost" | "amber" | "danger";
}) {
  const styles: Record<string, string> = {
    primary: "bg-[var(--color-pitch)] text-white active:bg-[var(--color-pitch-dark)]",
    amber: "bg-[var(--color-amber)] text-[var(--color-ink)] active:brightness-95",
    ghost: "bg-white text-[var(--color-ink)] border border-[var(--color-line)] active:bg-[var(--color-paper)]",
    danger: "bg-white text-red-700 border border-red-300 active:bg-red-50",
  };
  return (
    <button
      className={`tap rounded-2xl px-5 text-lg font-bold h-display disabled:opacity-40 ${styles[variant]} ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
}

export function Chip({
  active,
  children,
  onClick,
}: {
  active?: boolean;
  children: ReactNode;
  onClick?: () => void;
}) {
  return (
    <button
      onClick={onClick}
      className={`rounded-full px-4 py-2.5 text-base font-semibold border transition ${
        active
          ? "bg-[var(--color-pitch)] text-white border-[var(--color-pitch)]"
          : "bg-white text-[var(--color-ink)] border-[var(--color-line)]"
      }`}
    >
      {children}
    </button>
  );
}

export function Screen({
  title,
  right,
  children,
}: {
  title: string;
  right?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="mx-auto min-h-full w-full max-w-xl px-4 pb-28 pt-[max(1rem,env(safe-area-inset-top))]">
      <header className="mb-4 flex items-center justify-between gap-3">
        <h1 className="h-display text-4xl text-[var(--color-pitch-dark)]">{title}</h1>
        {right}
      </header>
      {children}
    </div>
  );
}

export function BlockTag({ label }: { label: string }) {
  return (
    <span className="h-display rounded-md bg-[var(--color-pitch)] px-2 py-0.5 text-sm text-white">
      {label}
    </span>
  );
}
